import styled from "styled-components";

export const Caption = styled.div`
  font-size: 22px;
  color: #333;
  font-weight: 400;
`;

export const ModalContent = styled.div`
  padding: 50px 60px;
`;
